import { parseMajorAmount, checkedMinorTotal, type InvoiceOutput } from '@1financial/shared';
type Line = InvoiceOutput['lineItems'][number];

export function invoiceAmountLine(line: Line, value: string, currency: Line['amount']['currency']): Line {
  const amount = parseMajorAmount(value);
  if (amount === line.amount.amount && line.amount.currency === currency && line.unitPrice.currency === currency) return line;
  return { ...line, quantity: 1, unitPrice: { amount, currency }, amount: { amount, currency } };
}

export function invoiceDraftTotals(lines: Line[]) {
  const subtotal = checkedMinorTotal(lines.map((line) => line.amount.amount));
  const tax = checkedMinorTotal(lines.map((line) => Math.round(line.amount.amount * line.vatRate / 100)));
  return { subtotal, tax, total: checkedMinorTotal([subtotal, tax]) };
}
